import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/client_service.jpg";
import Tilt from "react-parallax-tilt";
import {
  AiFillFacebook
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Hola <span className="purple"> Somos </span> NAAN
            </h1>
            <p className="home-about-body">
              NAAN nace de la necesitad expresada de contar con un proveedor de soluciones más que solo un proveedor de software.
              <i>
                <b className="purple"> No solo vendemos programas de cómputo, </b>
              </i>
              acompañamos a nuestros clientes a encontrar una mejor solución &nbsp;
              <i>
                <b className="purple">y tener un mejor servicio. </b> 
              </i>
              <br />
              <br />
             
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Encuentranos en</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://facebook.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
